<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <div class="active section">
                Relatório de Listagem de Parcelas
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div ref="modal" class="ui large modal" style="top: 40px">
        <iframe
          ref="viewer"
          width="100%"
          style="height: calc(100vh - 100px)"
        ></iframe>
      </div>
      <form
        :class="['ui small', { error: anyError }, 'form']"
        v-autocomplete-off
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="ten wide column">
              <div class="four wide field">
                <label for="invoices-report-state">Situação</label>
                <select
                  id="invoices-report-state"
                  class="ui dropdown"
                  v-model="form.state"
                >
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state.name"
                  >
                    {{ state.description }}
                  </option>
                </select>
              </div>
              <div class="four wide field">
                <label for="invoices-report-state">Convênio</label>
                <select
                  id="invoices-report-covenant"
                  class="ui dropdown"
                  v-model="form.covenant"
                >
                  <option
                    v-for="(covenant, index) in paymentMethods"
                    :key="index"
                    :value="covenant.name"
                  >
                    {{ covenant.description }}
                  </option>
                </select>
              </div>
              <div class="ui field">
                <label for="">Data de Vencimento</label>
              </div>
              <div class="inline fields">
                <div
                  :class="[
                    'four wide',
                    { error: errors.due_date_start },
                    'field'
                  ]"
                  :data-content="errorsTo('due_date_start')"
                >
                  <label for="invoices-report-due-date-start">De:</label>
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="invoices-report-due-date-start"
                    v-model="form.due_date_start"
                  />
                </div>
                <div
                  :class="[
                    'four wide',
                    { error: errors.due_date_end },
                    'field'
                  ]"
                  :data-content="errorsTo('due_date_end')"
                >
                  <label for="invoices-report-due-date-end">Até</label>
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="invoices-report-due-date-end"
                    v-model="form.due_date_end"
                  />
                </div>
              </div>
              <div class="ui field">
                <label for="">Data de Pagamento</label>
              </div>
              <div class="inline fields">
                <div
                  :class="[
                    'four wide',
                    { error: errors.payment_date_start },
                    'field'
                  ]"
                  :data-content="errorsTo('payment_date_start')"
                >
                  <label for="invoices-report-payment-date-start">De:</label>
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="invoices-report-payment-date-start"
                    v-model="form.payment_date_start"
                  />
                </div>
                <div
                  :class="[
                    'four wide',
                    { error: errors.payment_date_end },
                    'field'
                  ]"
                  :data-content="errorsTo('payment_date_end')"
                >
                  <label for="invoices-report-payment-date-end">Até</label>
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="invoices-report-payment-date-end"
                    v-model="form.payment_date_end"
                  />
                </div>
              </div>
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="run"
                  type="button"
                  name="run"
                  class="ui submit blue button"
                >
                  <i class="play icon"></i>Gerar Relatório
                </button>
              </div>
            </div>
          </div>
          <!-- row -->
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import { mapGetters } from 'vuex';

export default {
  components: { Breadcrumb, PageLayout },

  data() {
    return {
      loading: false,
      loaded: false,
      errors: {},
      form: {
        state: null,
        covenant: null,
        due_date_start: null,
        due_date_end: null,
        payment_date_start: null,
        payment_date_end: null
      },
      states: [
        { name: 'late', description: 'Atrasado' },
        { name: 'open', description: 'Em dias' },
        { name: 'paid', description: 'Pago' }
      ]
    };
  },

  computed: {
    anyError() {
      return !_.isEmpty(this.errors);
    },

    ...mapGetters({
      paymentMethods: 'settings/paymentMethods'
    })
  },

  mounted() {
    this.getUsers();
    $('.ui.dropdown').dropdown();
  },

  methods: {
    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    run() {
      this.loading = true;
      let data = {
        report: 'invoices'
      };

      if (
        !_.isEmpty(this.form.due_date_start) &&
        !_.isEmpty(this.form.due_date_end)
      ) {
        data.DUE_DATE_START = this.$moment(
          this.form.due_date_start,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD');

        data.DUE_DATE_END = this.$moment(
          this.form.due_date_end,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD');
      }

      if (
        !_.isEmpty(this.form.payment_date_start) &&
        !_.isEmpty(this.form.payment_date_end)
      ) {
        data.PAYMENT_DATE_START = this.$moment(
          this.form.payment_date_start,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD');

        data.PAYMENT_DATE_END = this.$moment(
          this.form.payment_date_end,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD');
      }

      if (!_.isEmpty(this.form.state)) {
        data.STATE = this.form.state;
        data.STATE_DESCRIPTION = this.states.find(
          state => state.value === this.form.state
        )?.description;
      }

      if (!_.isEmpty(this.form.covenant)) {
        data.COVENANT = this.form.covenant;
        const covenantDescriptions = this.paymentMethods.find(
          covenant => covenant.name === this.form.covenant
        )?.description;

        data.COVENANT_DESCRIPTION = `'${covenantDescriptions}'`;
      }

      Api.report(data)
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          $(this.$refs.viewer).attr('src', window.URL.createObjectURL(blob));
          $(this.$refs.modal).modal('show');
        })
        .catch(error => {
          this.showError = true;
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getUsers() {
      this.loading = true;
      const query = {
        q: {
          rule_eq: 'collaborator',
          s: ['name asc']
        }
      };

      Api.users
        .search(query)
        .then(async response => {
          this.collaborators = _.clone(response.data.users);
        })
        .catch(error => {
          this.$toast.show('Erro ao buscar colaboradores', 'error');
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
